import { registerSectionType } from "../../utils/sectionRegistry";
import { Section } from "../sectionHelpers";
import { resolveImageUrl } from "../../../../utils/imageUtils";

registerSectionType({
  type: "bloqueComercial",
  label: "Bloque comercial",
  layout: "simple",
  previewBlocks: ["Imagen", "Imagen"],
  getDefaults: () => ({
    type: "bloqueComercial",
    title: "",
    imageLeft: null,
    imageRight: null,
    toLeft: "",
    toRight: "",
  }),
  render: (section, index) => {
    const imgLeft = resolveImageUrl(section?.imageLeft?.src || section?.imageLeft || null);
    const imgRight = resolveImageUrl(section?.imageRight?.src || section?.imageRight || null);
    const toLeft = section?.toLeft || "";
    const toRight = section?.toRight || "";

    const renderColumn = (imgSrc, to, side) => {
      const colClass = imgSrc
        ? "bloque-comercial-col"
        : "bloque-comercial-col bloque-comercial-col--fallback";
      const colStyle = imgSrc ? { backgroundImage: `url(${imgSrc})` } : undefined;
      if (to) {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a key={`bc-${side}-${index}`} href={to} target="_blank" rel="noreferrer noopener" className={colClass} style={colStyle} />
        );
      }
      return <div key={`bc-${side}-${index}`} className={colClass} style={colStyle} />;
    };

    return (
      <Section section={section} keyName={`bloque-comercial-${index}`} className="bloque-comercial-section">
        <div className="bloque-comercial-grid">
          {renderColumn(imgLeft, toLeft, "left")}
          {renderColumn(imgRight, toRight, "right")}
        </div>
      </Section>
    );
  },
});
